import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useCancelConfirm = () => {
  const { t } = useTranslation();

  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('transaction_items.confirm.cancel.title'),
      body: t('transaction_items.confirm.cancel.message'),
      cancelButtonProps: {
        isTertiary: true,
        children: t('transaction_items.confirm.cancel.button.return'),
        testId: 'transaction_items.confirm.cancel.button.return',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t('transaction_items.confirm.cancel.button.confirm'),
        testId: 'transaction_items.confirm.cancel.button.confirm',
      },
    }),
    [t]
  );

  return useConfirmModal(args);
};
